"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  jcb: {
    'opt-protect': {
      loginScan: '扫码验证',
      passwordLogin: '安全码验证',
      smsDescribe: "\u6B64\u64CD\u4F5C\u4E3A\u654F\u611F\u64CD\u4F5C<br>\n      \u9700\u901A\u8FC7<strong>\u77ED\u4FE1\u9A8C\u8BC1</strong>\u540E\u624D\u53EF\u7EE7\u7EED",
      emailDescribe: "\u6B64\u64CD\u4F5C\u4E3A\u654F\u611F\u64CD\u4F5C<br>\n      \u9700\u901A\u8FC7<strong>\u90AE\u7BB1\u9A8C\u8BC1</strong>\u540E\u624D\u53EF\u7EE7\u7EED",
      contentHelpLabel: {
        app: '京东智联云 App'
      },
      qr: {
        introduction: '使用京东智联云 App 进行扫码',
        help: '帮助',
        download: '下载',
        refresh: '刷新',
        fetchErrorMsg: '加载错误'
      },
      form: {
        placeholder: '请输入 6 位验证码',
        placeholderSecurity: '请输入 6 位安全码',
        confirm: '验证',
        help: '帮助',
        download: '下载',
        invalidateLength: '验证码不足 6 位',
        invalidateSecurityLength: '安全码不足 6 位',
        getVeriCode: '点击获取验证码',
        replacePhone: '更换手机号码',
        replaceEmail: '更换邮箱',
        invalidateType: '验证码必须是数字',
        invalidateSecurityType: '安全码必须是数字'
      }
    },
    monitorDashboard: {
      colon: '：',
      period: '周期',
      aggregateType: '聚合方式',
      noPermission: '无查看监控图的权限，请联系管理员为您添加。'
    },
    'tag-edit': {
      selectedResourceCount: '已选资源个数：{count}',
      popupTitle: '添加 / 移除标签',
      ruleText: '添加/移除规则',
      emptyText: '暂无数据',
      rule: {
        comment: "<p>\u6BCF\u4E2A\u6807\u7B7E\u7531 1 \u4E2A\u201C\u952E\u201D\u548C 1 \u4E2A\u201C\u503C\u201D\u7EC4\u6210\uFF0C\u4F8B\u5982\uFF1A \u201C\u90E8\u95E8 : \u57FA\u7840\u7814\u53D1\u90E8\u201D\u3002</p>\n        <p>\u4F60\u53EF\u4EE5\u5728\u6B64\u9875\u9762\u7F16\u8F91\u9009\u5B9A\u8D44\u6E90\u7684\u6807\u7B7E\uFF0C\u901A\u8FC7\u70B9\u51FB\u201C\u6DFB\u52A0\u201D\u6216\u201C\u5220\u9664\u201D\u8FDB\u884C\u6807\u7B7E\u7684\u7ED1\u5B9A\u4E0E\u89E3\u7ED1\uFF0C\u70B9\u51FB\u5E95\u90E8\u201C\u786E\u8BA4\u201D\u63D0\u4EA4\u4F60\u5BF9\u8D44\u6E90\u6807\u7B7E\u7684\u64CD\u4F5C\u3002</p>\n        <p>\u6BCF\u4E2A\u8D44\u6E90\u6700\u591A\u5141\u8BB8\u7ED1\u5B9A 10 \u4E2A\u4E0D\u540C\u7684\u6807\u7B7E\uFF0C\u540C\u4E00\u8D44\u6E90\u6BCF\u4E2A\u6807\u7B7E\u201C\u952E\u201D\u4E0A\u53EA\u80FD\u5B58\u57281\u4E2A\u6807\u7B7E\u201C\u503C\u201D\u3002</p>",
        resourceIds: '最多支持同时编辑 100 个资源的标签，请取消选定部分资源后重试。'
      },
      tagType: {
        tagTemplate: '标签模板',
        tag: '现有标签'
      },
      form: {
        rules: {
          selectValueLength: '长度为 1 到 255 个字符',
          selectKeyLength: '长度为 1 到 127 个字符',
          character: '标签键值不能以 ”jrn:“ 或 ”jdc-“开头，仅支持中文，大小写英文、数字及如下符号_.,:/=+-@',
          notag: '不能命名“标签值”为 “notag”'
        },
        currentTagLabel: '当前标签：',
        currentTagTable: {
          del: '删除',
          delAll: '全部删除',
          tagKey: '标签键',
          tagValue: '标签值',
          multiTagValue: '多标签值',
          resourceCount: '资源数',
          operation: '操作'
        },
        addTag: {
          label: '添加标签：',
          placeholder: '请选择',
          keyPrefix: '键',
          valuePrefix: '值',
          add: '添加',
          invalided: '同一个资源上绑定的标签不得超过10个，请删除部分标签后再添加新标签。',
          invalidedResourceId: '资源 id：{resourceId} 超过最大限制'
        },
        ok: '确定',
        cancel: '取消'
      },
      result: {
        resourceId: '资源 ID：{resourceId}',
        updateComplete: '资源更新标签完成，其中',
        haveFailedCount: '个资源更新失败，具体原因请查看下方详情',
        ok: '确定',
        cancel: '取消'
      }
    },
    'tag-filter': {
      title: '选择标签键 / 标签值',
      placeholder: '输入键 / 值搜索',
      filter: '筛选',
      tooltip: '标签筛选',
      notag: '未打标',
      notagHelp: '通过选中此项来筛选未打该“标签键”的资源。',
      emptyText: '暂无数据'
    },
    'tag-creationform': {
      add: ' 添加',
      emptyText: '暂无数据',
      key: '标签键',
      value: '标签值',
      placeholderKey: '输入/选择键',
      placeholderValue: '输入/选择值',
      tooltip: "<p>\u6BCF\u4E2A\u6807\u7B7E\u7531 1 \u4E2A\u201C\u952E\u201D\u548C 1 \u4E2A\u201C\u503C\u201D\u7EC4\u6210\uFF0C\u4F8B\u5982\uFF1A\u201C\u90E8\u95E8:\u57FA\u7840\u7814\u53D1\u90E8\u201D\uFF0C</p>\n                <p>\u901A\u8FC7\u6807\u7B7E\u4F60\u53EF\u6309\u4E0D\u540C\u7684\u7EF4\u5EA6\u6279\u91CF\u7BA1\u7406\u8D44\u6E90\u3002</p>\n                <p>\u6807\u7B7E\u952E\u503C\u4E0D\u80FD\u4EE5 \u201Cjrn:\u201D \u6216 \u201Cjdc-\u201D\u5F00\u5934\uFF0C\u4EC5\u652F\u6301\u4E2D\u6587\uFF0C\u5927\u5C0F\u5199\u82F1\u6587\u3001\u6570\u5B57</p>\n                <p>\u53CA\u5982\u4E0B\u7B26\u53F7\"_.,:/=+-@\"\u3002<a target=\"_blank\" style=\"color: white;font-size: 12px;text-decoration: underline\" href=\"https://docs.jdcloud.com/cn/tag-service/product-overview\">\u8BE6\u60C5\u8BF4\u660E ></a></a></p>",
      rules: {
        selectValueLength: '长度为 1 到 255 个字符',
        selectKeyLength: '长度为 1 到 127 个字符',
        character: '标签键值不能以 “jrn:” 或 “jdc-”开头，仅支持中文，大小写英文、数字及如下符号_.,:/=+-@',
        notag: '不能命名“标签值”为 “notag”',
        requiredStrict: '不能为空',
        requiredKey: '标签键不能为空， 请添加后重试。',
        requiredValue: '标签值不能为空， 请添加后重试。',
        maximumLimit: '每个资源最多绑定 10 个标签，请删除部分标签后再试。',
        duplicateKey: '标签键不能重复，请删除后重试。'
      }
    },
    iaasDisk: {
      diskType: '类型',
      type_sell_out: '售罄',
      change_type: '已售罄，请更换类型',
      capacity: '容量',
      snapshot: '快照',
      auto_assign_name: '自动分配设备名',
      data_name_range: '数据盘设备名范围',
      deviceName: '设备名',
      see_detailRule: '具体规则点此详见',
      after_create_encrypt_no_change: '创建后磁盘加密属性不可修改',
      release_with_vm: '随云主机释放',
      encrypt: '加密',
      encryption_cannot_change: '加密属性从快照/镜像继承且不可修改',
      exceed_specified_diskType_capacity: '所选快照容量已超过指定类型云硬盘可创建容量上限'
    },
    'combined-search': {
      noMatchKey: '没有符合的搜索条件，请重新输入',
      matchKeyExist: '当前搜索条件已存在',
      searchTip: '在此处指定搜索条件进行联合搜索',
      searchTipInEditMode: '回车键表示确定，“← ”、"→ "键可选中已生成的搜索项，Esc键可取消选中或收起下拉框。',
      searchIconTip: '将根据搜索框中已生成的搜索项进行搜索',
      clearIconTip: '清空搜索框',
      chooseFilterKey: '选择搜索条件',
      confirm: '确认',
      cancel: '取消',
      noAvailableKey: '未匹配到搜索条件，将使用"{0}"搜索',
      activeTagTip: '单击或回车键进行编辑',
      instructions: {
        help: '使用帮助',
        federatedSearchHelp: '联合搜索使用帮助',
        functionalTip: '联合搜索可帮助您根据单个或多个搜索条件对您的云主机进行搜索。',
        useTip: '您需要先指定搜索条件并输入搜索条件值，使用回车键生成搜索项，再次回车或点击搜索图标触发搜索。',
        specSearchCriteria: '指定搜索条件',
        specMethod: '指定方式',
        keyboardInput: '键盘输入',
        dropdownSelect: '下拉框选择',
        examples: '示例',
        exampleKeyLabel: '主机名称',
        inputFormat: '输入格式',
        searchCriteria: '「搜索条件」',
        colon: '「冒号」',
        none: '无',
        operationDisplay: '过程展示',
        enterSearchCriteriaValue: '输入搜索条件值',
        criteriaValueNumber: '条件值个数',
        singleValue: '单个',
        multiValue: '多个',
        specifiedSearchCriteria: '已选择搜索条件',
        exampleSingleValueKey: '公网IPv4',
        exampleMultiValueKey: '实例规格',
        searchCriteriaValue: '搜索条件值',
        enter: '「回车」',
        comma: '「逗号」',
        deleteSearchTerm: '删除搜索项',
        deleteScope: '删除范围',
        all: '所有',
        deleteMethod: '删除方式',
        deleteByKeyboard: '键盘删除',
        deleteByMouse: '鼠标删除',
        deleteExampleTerm: '将删除搜索项',
        egKeyBoardInput: '输入“主机名称：” ',
        egDropdownSelect: '单击或回车选中',
        egInputSingleSearchValue: '输入搜索条件值：116.196.68.215，',
        egInputMultiSearchValue: '输入搜索条件值：g.n2.medium,g.s2.small,c.c2.large，',
        egPressEnter: '回车生成搜索项',
        egKeyboardDeleteTag: '使用方向键选中搜索项，使用删除键删除选中项',
        egMouseDeleteTag: '点击搜索项上删除图标删除当前搜索项',
        egKeyboardDeleteAll: 'Ctrl+A选中所有搜索项，使用删除键删除选中项',
        egMouseDeleteAll: '点击联合搜索框中删除图标清空联合搜索框'
      }
    },
    'subnet-select': {
      lazyFailed: '加载失败,请重新下拉刷新...',
      emptyText: '无子网数据',
      placeholder: '请选择子网',
      subnetId: '子网ID',
      subnetName: '子网名称',
      id: 'ID',
      name: '名称',
      inputKeyword: '输入{0}{1}搜索',
      precise: '精确',
      fuzzy: '模糊'
    },
    'vpc-select': {
      placeholder: '请选择私有网络',
      vpcId: '私有网络ID',
      vpcName: '私有网络名称',
      id: 'ID',
      name: '名称',
      inputKeyword: '输入{0}{1}搜索',
      emptyText: '无私有网络数据',
      precise: '精确',
      fuzzy: '模糊'
    },
    'ssh-select': {
      placeholder: '请选择SSH密钥',
      noMatchText: '无匹配选项',
      createSSH: '新建密钥',
      emptyText: '无可用SSH密钥',
      searching: '搜索中'
    },
    'bucket-select': {
      placeholder: '请选择Bucket',
      noMatchText: '无匹配选项',
      searching: '搜索中'
    },
    'securityGroup-select': {
      placeholder: '请选择安全组',
      networkSecurityGroupId: '安全组ID',
      networkSecurityGroupName: '安全组名称',
      emptyText: '无安全组数据'
    },
    vpcLink: {
      name: '名称',
      copy: '复制',
      cancel: '取消',
      confirm: '确认',
      copySuccess: '复制成功',
      modifyName: '修改名称',
      nameRequired: '名称不能为空',
      nameLength: '名称长度不能超过32个字符',
      nameChart: '名称不可为空，只支持中文、数字、大小写字母、英文下划线“_”及中划线“-”'
    },
    docHelp: {
      resetSize: '恢复到原布局',
      helpTitle: '帮助文档',
      close: '关闭',
      goHelpCenter: '在帮助中心打开',
      onlineConsultation: '在线咨询'
    },
    'hosted-account-cascader': {
      systemAccount: '系统账号',
      hostedAccount: '被托管账号'
    },
    'vm-select': {
      placeholder: '请选择云主机',
      instanceId: '云主机ID',
      instanceName: '云主机名称',
      id: 'ID',
      name: '名称',
      inputKeyword: '输入{0}{1}搜索',
      emptyText: '无云主机数据',
      precise: '精确',
      fuzzy: '模糊'
    },
    hostedBill: {
      getUserInfoError: '获取用户信息失败',
      getHostedListError: '获取用户托管关系列表失败',
      notifyTitle: '提示',
      hasCouponPermission: '具有代金券发放权限',
      buttonText: '立即购买',
      dialog: {
        hostedDialogTitle: '替托管账号购买',
        hostedDialogLabel: '替托管账号购买',
        hostedDialogVoucherLabel: '使用代金券购买'
      },
      error: {
        '0000': {
          title: '提示',
          text: '当前用户 {user} 托管关系列表为空'
        },
        '0001': {
          title: '提示',
          text: '被托管账号 {hosted} 没有托管给当前账号'
        },
        '0002': {
          title: '提示',
          text: '被托管账号: {hosted} 的托管权限为只读权限，无法为该账号进行购买，建议告知业务放变更为管理员权限重新申请托管'
        },
        '0003': {
          title: '提示',
          text: ''
        },
        '0004': {
          title: '提示',
          text: '异常，刷新页面重试'
        }
      },
      actionSuccess: '代金券发放成功',
      actionFail: '代金券发放失败',
      buyNow: '立即购买',
      ok: '确定',
      cancel: '取消'
    },
    errorNotify: {
      copy: '复制',
      copySuccess: '复制成功',
      errorCode: '错误码',
      submitOrder: '提交工单',
      defaultMsg: '网络服务资源配置异常，请提交工单寻求帮助！'
    },
    'az-selector': {
      soldOut: '售罄',
      unusableArea: '无可用区'
    },
    regionSelector: {
      tip: '售罄',
      noData: '无地域'
    },
    cidr: {
      range: '范围'
    },
    chargeInfo: {
      chargeMode: {
        postpaid_by_duration: '按配置',
        prepaid_by_duration: '包年包月',
        postpaid_by_usage: '按用量'
      },
      chargeItem: {
        maturity: '到期',
        expired: '已过期',
        freed: '释放',
        arrear: '已欠费'
      }
    },
    billPeriod: {
      months: {
        one: '{n} 个月',
        other: '{n} 个月'
      },
      years: {
        one: '{n} 年',
        other: '{n} 年'
      }
    },
    datetimeRangeSelector: {
      apply: '应用',
      beginTime: '开始时间',
      endTime: '结束时间',
      to: '至',
      lastOneMonth: '最近一月',
      lastOneWeek: '最近一周',
      lastHours: '最近{n}小时',
      lastMinutes: '最近{n}分钟',
      today: '今天',
      yesterday: '昨天',
      thenDayBeforeYesterday: '前天',
      custom: '自定义',
      requiredValue: '缺少初始value',
      rangeError: '相对时间范围不正确',
      cantFind: '未找到对应的RELATIVE_TIME_OPTIONS数据',
      tip: '请填写有效的开始时间和结束时间'
    },
    'time-offset-selector': {
      ringRatio: '环比',
      custom: '自定义',
      periodTip: '以当前查询时间跨度为基准向前推',
      customTip: '选择开始时间，系统自动计算结束时间',
      donotcompare: '不对比',
      confirm: '确定',
      period1: '前1个周期',
      periodmore1: '前{num}个周期'
    },
    renew: {
      prepaid_by_duration: '续费',
      postpaid_by_duration: '转包年包月'
    },
    operationChck: {
      cannotOp: '当前实例状态不允许操作',
      noCharge: '当前计费状态不支持操作'
    },
    whiteList: {
      modify: '编辑',
      modifyTitle: '编辑白名单',
      editMode: '编辑方式',
      editSuccess: '编辑成功',
      textEdit: {
        title: '文本编辑',
        tipA: '指定 IP 地址：192.168.0.1 （允许192.168.0.1的 IP 地址访问）',
        tipIpv6A: '指定 IP 地址：192.168.0.1 （允许192.168.0.1的 IP 地址访问），支持IPV6地址',
        tipB: '指定 IP 段：192.168.0.0/24 （允许192.168.0.1到192.168.0.255的 IP 地址访问）',
        tipIpv6B: '192.168.0.0/24 （允许192.168.0.1到192.168.0.255的 IP 地址访问），支持IPV6 CIDR',
        tipC1: '多个 IP 设置，用',
        tipC2: '英文逗号或回车',
        tipC3: '隔开',
        tipD: '白名单中的0.0.0.0/0表示允许所有地址访问，请慎重考虑',
        tipIpv6D: '白名单中的0.0.0.0/0（IPV4地址）或 ::/0（IPV6地址）表示允许所有地址访问，请慎重考虑',
        ips: 'IP列表：'
      },
      host: {
        title: '从云主机选择',
        emptyText: '当前VPC无可用云主机',
        tipVpc: '此处仅列出本VPC内的云主机',
        tipMax1: '还可添加',
        tipMax2: '个白名单',
        selectAll: '全选'
      },
      rules: {
        lengthMin: '白名单中必须至少有一个IP或IP段',
        lengthMax: '白名单最多允许50个IP或IP段',
        illegal: '提交的数据包含不合法的IP、IP段，请检查后再次提交',
        duplicate: '提交的数据包含重复的IP、IP段，请检查后再次提交',
        totalIps: '白名单总数不能超过{totalNum}个'
      }
    }
  },
  loading: '加载中',
  searching: '搜索中',
  confirm: '确定',
  cancel: '取消'
};
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@jdcloud/jelement-biz/dist/locale/lang/zh-CN.js
// module id = vCAO
// module chunks = 19